export default {
    hasHydration: false,
    editModalIsOpen: false,
    confirmModalIsOpen: false,
    program: {},
    isFetchingProgram: true,
    isPublishingNeeds: false,
    isCreatingNeeds: false,
    isSavingCriteria: false,
    isDeletingNeed: false,
    isRedirecting: false,
    activeNeed: {},
    activeNeedCriteria: [],
    coachSelectedNeeds: {},
    coachCheckedNeeds: [], // The IDs of the needs that are currently selected
    feetAndInchesFields: [
        'height_inches',
        'jump_inches',
        'block_inches',
        'reach_inches',
        'vertical_inches',
    ],
    additionalSportFields: {
        1: [ //lacrosse
            'dominant_hand',
        ],
        2: [ //volleyball
            'dominant_hand',
            'jump_inches',
            'block_inches',
            'reach_inches',
            'vertical_inches',
            'vpi_pct',
        ],
        4: [ //soccer
            'dominant_foot',
        ],
        5: [ //softball
            'bats',
            'throws',
            'fb_best',
            'exit_velo',
            'pop',
            'sixty_yard_time',
        ],
        6: [ //baseball
            'bats',
            'throws',
            'fb_best',
            'exit_velo',
            'pop',
            'sixty_yard_time',
        ],
    },
    fieldOrder: [
        'video_required',
        'gpa',
        'act',
        'sat',
        'height_inches',
        'weight',
        'dominant_hand',
        'dominant_foot',
        'jump_inches',
        'block_inches',
        'reach_inches',
        'vertical_inches',
        'vpi_pct',
        'bats',
        'throws',
        'fb_best',
        'exit_velo',
        'pop',
        'sixty_yard_time',
    ]
};